import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgSlashIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 16.875L11 1.125", stroke: "#E0DEE3", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.33333 }));
});
export default SvgSlashIcon;
